// Maps a monitoring procedure code to its Font Awesome icon name (style-agnostic).
// Callers compose the style at the point of use, e.g. ['fal', name] or ['fas', name].
const PROCEDURE_ICONS = {
    'quant-veg': 'tree-alt',
    'qual-veg': 'clipboard-list',
    'photo': 'camera',
    'instream-shade': 'sun',
};

export default class IconUtils {
    static GetProcedureIconName(code) {
        return PROCEDURE_ICONS[code] ?? 'calendar';
    }
}
